import { axios } from '@/lib/helpers';
import { createAction } from '@reduxjs/toolkit';

export const fetchSystemStatusStarted = createAction('system-status/fetch/started');
export const fetchSystemStatusSucceeded = createAction('system-status/fetch/succeeded');
export const fetchSystemStatusFailed = createAction('system-status/fetch/failed');

export const fetchSystemStatus =
  (flushCache = false) =>
  (dispatch) => {
    dispatch(fetchSystemStatusStarted());
    const flushParam = flushCache ? '1' : '0';
    return axios({
      method: 'get',
      url: '/system-status/?flush=' + flushParam,
    }).then(
      ({ data }) => dispatch(fetchSystemStatusSucceeded(data.data)),
      ({ message }) => dispatch(fetchSystemStatusFailed(message))
    );
  };
